import { normalizeTemplate, templatePage, savedTemplate, templateResult, templateRestorePreview, restoredTemplate } from './templates'
export function normalizeComponentResource (value) {
  if (!value || value.resourceType !== 'component' || value.kind !== 'component') throw new Error('组件资源类型不一致，请刷新组件列表')
  const match = /^builtin_(\d+)_(\d+)$/.exec(value.id)
  if (match && (value.visibility !== 'public' || value.creatorId !== '1199596756811550720')) throw new Error('系统组件归属或公开范围不正确，请核对初始化数据')
  return { ...normalizeTemplate(value), resourceType: 'component', creatorId: value.creatorId,
    ...(match ? { isSystem: true, registered: true, systemKey: match[1] + ':' + match[2] } : {}) }
}
export function componentResourcePage (response) {
  const page = templatePage(response)
  return { ...page, data: templateResult(response).data.map(normalizeComponentResource) }
}
export function savedComponentResource (response, previous, expectedCoverFileId) {
  savedTemplate(response, previous, expectedCoverFileId)
  return normalizeComponentResource(templateResult(response))
}
export function componentRestorePreview (response, id) {
  const result = templateResult(response)
  normalizeComponentResource(result.current); normalizeComponentResource(result.previous)
  const preview = templateRestorePreview(response, id, 'component')
  return { ...preview, current: normalizeComponentResource(result.current), previous: normalizeComponentResource(result.previous) }
}
export function restoredComponentResource (response, preview) {
  restoredTemplate(response, preview)
  return normalizeComponentResource(templateResult(response))
}
export function componentResourceError (error) { return error && error.status === 404 ? '组件接口尚未部署，请更新并重启后端后重试' : error && error.message || '组件加载失败，请重试' }
// 系统登记分类不属于自建分类；已有自建子分类提升显示，避免被一并隐藏。
export function customComponentCatalogs (tree) {
  return tree.flatMap(item => {
    const children = customComponentCatalogs(item.children || [])
    return item.id === 'res_component_default' ? children : [{ ...item, children }]
  })
}
